import React from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css'; // Import default tooltip styles

const Footer = () => {
  // Function to show toast notification
  const showToast = (message) => {
    toast.success(message, { autoClose: 5000 });
  };
  return (
    <div>
      <ToastContainer />
      <Tooltip
        id="process-tooltip"
        place="right"
        effect="solid"
        className="!bg-zinc-200 !text-black !rounded-lg !p-4 !text-sm !shadow-lg"
      />
    <footer className="bg-black text-white py-12">
      <div className="container mx-auto px-4 md:px-8">
        {/* Customer Support Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-12 mb-12 text-center md:text-left">
            <div>
              <h3 className="font-bold mb-4">Customer Support</h3>
              <ul>
                <li><a href="#general-assistance" className="hover:underline">General Assistance</a></li>
                <li><a href="/faqs" className="hover:underline">Frequently Asked Questions</a></li>
                <li>
                  <a
                    href="#warranty"
                    className="hover:underline"
                    data-tooltip-id="process-tooltip"
                    data-tooltip-content="Register your product to avail warranty benefits"
                  >
                    Warranty Registration
                  </a>
                </li>
                <li>
                  <a
                    href="#replacement"
                    className="hover:underline"
                    data-tooltip-id="process-tooltip"
                    data-tooltip-content="Request replacement parts for your product"
                  >
                    Replacement Parts
                  </a>
                </li>
              </ul>
            </div>

          {/* Partner With Us */}
          <div>
            <h3 className="font-bold mb-4">Partner With Us</h3>
            <ul>
              <li><a href="#custom-integrator" className="hover:underline">Custom Integrator Program</a></li>
              <li><a href="#installer" className="hover:underline">Installer Program</a></li>
              <li><a href="#dealer" className="hover:underline">Dealer Program</a></li>
            </ul>
          </div>

          {/* About Us */}
          <div>
            <h3 className="font-bold mb-4">About Us</h3>
            <ul>
  <li>
    <a 
      href="https://www.ssgfurnishings.com" 
      target="_blank" 
      rel="noopener noreferrer" 
      className="hover:underline"
    >
      SSG Furnishing Global
    </a>
  </li>
</ul>
          </div>

          {/* Essential Resources */}
          <div>
            <h3 className="font-bold mb-4">Essential Resources</h3>
            <ul>
              <li><a href="#child-safety" className="hover:underline">Child Safety</a></li>
              <li><a href="#light-control" className="hover:underline">Light Control & Privacy</a></li>
              <li><a href="#energy-efficiency" className="hover:underline">Energy Efficiency</a></li>
              <li><a href="#design-guide" className="hover:underline">Free Design Guide</a></li>
            </ul>
          </div>
        </div>

        {/* Social Media & Contact Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-12 text-center md:text-left">
          {/* Social Media */}
          <div>
            <h3 className="font-bold mb-4">Social Media</h3>
            <ul className="flex justify-center sm:justify-start space-x-4">
              <li><a href="https://facebook.com" className="hover:underline"><img src="images/fb.png" alt="Facebook" className="w-6 h-6" /></a></li>
              <li><a href="https://instagram.com" className="hover:underline"><img src="images/insta.png" alt="Instagram" className="w-6 h-6" /></a></li>
              <li><a href="https://linkedin.com" className="hover:underline"><img src="images/linkedin.png" alt="LinkedIn" className="w-6 h-6" /></a></li>
              <li><a href="https://twitter.com" className="hover:underline"><img src="images/x.png" alt="Twitter" className="w-6 h-6" /></a></li>
              <li><a href="mailto:info@ssgfurnishings.com" className="hover:underline"><img src="images/mail.png" alt="Email" className="w-6 h-6" /></a></li>
            </ul>
          </div>

          {/* Contact Us */}
          <div>
            <h3 className="font-bold mb-4">Contact Us</h3>
            <div className="flex justify-center sm:justify-start gap-2 items-center">
              <img src="images/mobile.png" alt="Phone" className="w-6 h-6" />
              <p>+1 (647) 213-5742<br />Monday-Friday 9:00 am - 8:00 pm EST</p>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-600 my-8"></div>

        {/* Footer Bottom */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 items-center text-center sm:text-left">
          {/* Powered By */}
          <div className="flex items-center justify-center sm:justify-start space-x-2">
            <p>Powered by ALIF DYNAMICS Inc. Canada</p>
          </div>

          {/* Logo & Copyright */}
          <div className='flex gap-4'>
            <img src="images/logo.png" alt="SSG Furnishing" className="h-8 mx-auto sm:mx-0" />
            <p className="text-sm mt-2">©2024 SSG Furnishing. All Rights Reserved.</p>
          </div>

          {/* Legal Links */}
          <div className="flex justify-center sm:justify-end">
            <ul className="flex justify-center sm:justify-end space-x-4 text-sm">
              <li><a href="#sitemap" className="hover:underline">Site Map</a></li>
              <li><a href="#privacy-policy" className="hover:underline">Privacy Policy</a></li>
              <li><a href="#terms-of-use" className="hover:underline">Terms of Use</a></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
    </div>

  );
};

export default Footer;


// import React from 'react';

// const Footer = () => {
//   return (
//     <footer className="bg-black text-white py-12">
//       <div className="container mx-auto px-4 md:px-8">
//         {/* Customer Support Section */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-12 mb-12 text-center md:text-left">
//           <div>
//             <h3 className="font-bold mb-4">Customer Support</h3>
//             <ul>
//               <li><a href="#general-assistance" className="hover:underline">General Assistance</a></li>
//               <li><a href="#faq" className="hover:underline">Frequently Asked Questions</a></li>
//               <li><a href="#warranty" className="hover:underline">Warranty Registration</a></li>
//               <li><a href="#replacement-parts" className="hover:underline">Replacement Parts</a></li>
//               <li><a href="#rebate" className="hover:underline">Rebate Status</a></li>
//               <li><a href="#accessibility" className="hover:underline">Website Accessibility</a></li>
//             </ul>
//           </div>

//           <div>
//             <h3 className="font-bold mb-4">Partner With Us</h3>
//             <ul>
//               <li><a href="#custom-integrator" className="hover:underline">Custom Integrator Program</a></li>
//               <li><a href="#installer" className="hover:underline">Installer Program</a></li>
//               <li><a href="#dealer" className="hover:underline">Dealer Program</a></li>
//               <li><a href="#dealer-login" className="hover:underline">Dealer Login</a></li>
//             </ul>
//           </div>

//           <div>
//             <h3 className="font-bold mb-4">About Us</h3>
//             <ul>
//               {/* <li><a href="#ethics" className="hover:underline">Ethics & Compliance</a></li> */}
//               <li><a href="https://www.ssgfurnishings.com" className="hover:underline">SSG Furnishing Global</a></li>
//               {/* <li><a href="#ethics" className="hover:underline">SSG Furnishing Architectural</a></li> */}
//             </ul>
//           </div>

//           <div>
//             <h3 className="font-bold mb-4">Essential Resources</h3>
//             <ul>
//               <li><a href="#child-safety" className="hover:underline">Child Safety</a></li>
//               <li><a href="#light-control" className="hover:underline">Light Control & Privacy</a></li>
//               <li><a href="#energy-efficiency" className="hover:underline">Energy Efficiency</a></li>
//               <li><a href="#design-guide" className="hover:underline">Free Design Guide</a></li>
//               <li><a href="#automation-app" className="hover:underline">PowerView® Automation App for iOS</a></li>
//             </ul>
//           </div>
//         </div>

//         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-12 text-center md:text-left">
//           <div>
//             <h3 className="font-bold mb-4">Social Media</h3>
//             <ul className="flex justify-center sm:justify-start space-x-4">
//               <li><a href="#facebook" className="hover:underline"><img src="images/fb.png" alt="Facebook" className="w-6 h-6" /></a></li>
//               <li><a href="#youtube" className="hover:underline"><img src="images/insta.png" alt="YouTube" className="w-6 h-6" /></a></li>
//               <li><a href="#pinterest" className="hover:underline"><img src="images/linkedin.png" alt="Pinterest" className="w-6 h-6" /></a></li>
//               <li><a href="#houzz" className="hover:underline"><img src="images/x.png" alt="Houzz" className="w-6 h-6" /></a></li>
//               <li><a href="#instagram" className="hover:underline"><img src="images/mail.png" alt="Instagram" className="w-6 h-6" /></a></li>
//             </ul>
//           </div>

//           <div>
//             <h3 className="font-bold mb-4">Contact Us</h3>
//             <div className="flex justify-center sm:justify-start gap-2 items-center">
//               <img src="images/mobile.png" alt="Instagram" className="w-6 h-6" />
//               <p>+1 (647) 213-5742<br />Monday-Friday 9:00 am - 8:00 pm EST</p>
//             </div>
//           </div>
//         </div>

//         {/* Divider */}
//         <div className="border-t border-gray-600 my-8"></div>

//         {/* Footer Bottom */}
//         <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 items-center text-center sm:text-left">

//           <div className="flex items-center justify-center sm:justify-start space-x-2">
//            <p>Powered by ALIF DYNAMICS Inc. Canada</p>
//           </div>

//           <div className='flex gap-4'>
//             <img src="images/logo.png" alt="SSG Furnishing" className="h-8 mx-auto sm:mx-0" />
//             <p className="text-sm mt-2">©2024 SSG Furnishing. All Rights Reserved.</p>
//           </div>
//           <div className="flex justify-center sm:justify-end">
//             <ul className="flex justify-center sm:justify-end space-x-4 text-sm">
//               <li><a href="#sitemap" className="hover:underline">Site Map</a></li>
//               <li><a href="#privacy-policy" className="hover:underline">Privacy Policy</a></li>
//               <li><a href="#terms-of-use" className="hover:underline">Terms of Use</a></li>
//             </ul>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;
